/* eslint-disable arrow-parens */
import { useState, useCallback, useEffect, useContext, useRef, Suspense } from "react";
import { ADMIN_DASHBOARD_HEADER } from "../../../constants/caption/dashboardHeader";
import { AuthContext, UIContext } from "../../../contexts";
import a11yScrollableProps from "../../../constants/tabPanelProps/ayScrollableProps";
import ScrollTabPanel from "../../shared/tabPanelComponent/ScrollTabPanel";

import { Box, Tab, Tabs } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import useRouteParam from "../../../hooks/useRouteParam";
import ExtractRouteParams from "../../../utils/commonFunctions/extractRouteParams";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../utils/api";
import ROLES from "../../../constants/roles";

import { useEmployerRoute, useEnroller } from "../../../hooks";
import {
	EnrollerReportManagement,
	GeneralReportManagement,
	LazyDataIntegrityReportManagement,
	LazyEnrollerReportManagement,
	LazyGeneralReportManagement
} from "..";
import YearlyOpenEnrollmentReport from "./yearlyOpenEnrollmentsReports/YearlyOpenEnrollmentReport";
import isEmployerRoute from "../../../utils/commonFunctions/isEmployerRoute";
import { getPermissionsFromGroupOwner } from "../../../utils/getPermissionsFromGroupOwner";
import CircularLoader from "../../shared/loader/CircularLoader";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1
		// backgroundColor: theme.palette.background.paper
	}
}));

const ReportManagement = (): JSX.Element => {
	const [reportsData, setReportsData] = useState<any[]>([]);
	const [reportsDataZero, setReportsDataZero] = useState<any[]>([]);
	const [loading, setLoading] = useState(true);
	const classes = useStyles();
	const { isEnroller } = useEnroller();
	const [value, setValue] = useState(0);
	const { user } = useContext(AuthContext);
	const { setDashboardHeader, setMemberUI } = useContext(UIContext);
	const querySSN = useRouteParam("qs");
	const queryGroupNumber = useRouteParam("gn");
	const routeParam = ExtractRouteParams(); // This is to extract the route after ?(Question Mark)

	const isEmployer = useEmployerRoute();

	const handleLabelChange = (event: any, value: number) => {
		setValue(value);
	};

	// console.log("queryGroupNumber=====", queryGroupNumber);

	const getReports = useCallback(async () => {
		try {
			setLoading(true);
			if (isEmployer) {
				if (!queryGroupNumber) {
					return;
				}

				const groupNumber = queryGroupNumber;
				const { employerReports, reports } = await api.reports.getReports({
					group_number: Number(groupNumber)
				});
				// console.log("employerReports=====", employerReports);
				setReportsData([...reports]);
			} else {
				const { employerReports, reports } = await api.reports.getReports({ group_number: 0 });
				setReportsDataZero([...reports]);
			}
		} finally {
			setLoading(false);
		}
	}, [queryGroupNumber, isEmployer]);

	const activeReports = queryGroupNumber ? reportsData : reportsDataZero;

	// const reportManagementPermission =
	// 		user && isEmployerRoute() && queryGroupNumber
	// 			? getPermissionsFromGroupOwner(user, Number(queryGroupNumber))?.reports_menu.self

	// 			: user
	// 				? getPermissionsFromGroupOwner(user, 0)?.dashboard_menu.self
	// 				: null;

	// Get unique report types from backend response
	const reportTypesList = Array.from(new Set(activeReports.map((report) => report.report_type)));

	// Map report types to components dynamically
	const componentMap: Record<string, (props: { dataReports: typeof activeReports }) => JSX.Element> = {
		"General Reports": (props) => <GeneralReportManagement {...props} />,
		"Enroller Reports": (props) => <EnrollerReportManagement {...props} />,
		"Yearly Open Enrollment Reports": (props) => <YearlyOpenEnrollmentReport {...props} />,
		"Data Integrity Reports": (props) => <LazyDataIntegrityReportManagement {...props} />
		// You can extend this easily when new types arrive from backend
	};

	// Build tabs dynamically
	const tabs = reportTypesList
		.filter((type) => componentMap[type]) // only include report types you have a component for
		.map((type) => {
			const filteredReports = activeReports.filter((report) => report.report_type === type);

			return {
				label: type,
				component: componentMap[type]({ dataReports: filteredReports })
			};
		});

	// const tabs = [
	// 	{
	// 		label: "General Reports",
	// 		component: <GeneralReportManagement dataReports={generalReports} />
	// 	},
	// 	// queryGroupNumber === null
	// 	// 	? { label: "Enroller Reports", component: <EnrollerReportManagement dataReports={reportsDataZero} /> }
	// 	// 	: queryGroupNumber === 220
	// 	// 	? { label: "BBI - Enroller Reports", component: <EnrollerReportManagement dataReports={reportsData} /> }
	// 	// 	: null,
	// 	{
	// 		label: "Enroller Reports",
	// 		component: <EnrollerReportManagement dataReports={enrollerReports} />
	// 	},
	// 	{
	// 		label: "Yearly Open Enrollment Reports",
	// 		component: <YearlyOpenEnrollmentReport dataReports={yearlyReports} />
	// 	},
	// 	{
	// 		label: "Data Integrity Reports",
	// 		component: <LazyDataIntegrityReportManagement dataReports={dataIntegrityReports} />
	// 	}
	// ].filter(Boolean) as { label: string; component: JSX.Element }[]; // Ensures TypeScript knows there are no null values.

	useEffect(() => {
		getReports();
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.report_management);
	}, [setDashboardHeader, getReports]);

	return (
		<div className="report-management-container" id="report-management-container">
			<div className="member-details-tab-panel-container" style={{ width: "auto" }}>
				{loading && <CircularLoader />}
				<div className={classes.root + " glb-tab-panel-container"}>
					<Box sx={{ width: "100%" }}>
						<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
							<Tabs
								value={value}
								onChange={handleLabelChange}
								TabIndicatorProps={{
									style: {
										border: "none",
										backgroundColor: "#558b2f"
									}
								}}
								variant="scrollable"
								scrollButtons="auto"
								aria-label="scrollable auto tabs example"
								className="glb-tab-panel"
							>
								{tabs.map((tab, index) => (
									<Tab key={index} label={tab.label} {...a11yScrollableProps(index)} />
								))}

								{/* {queryGroupNumber === 220 ? ( */}

								{/* ) : null} */}
							</Tabs>
							{tabs.map((tab, index) => (
								<ScrollTabPanel key={index} value={value} index={index}>
									<Suspense fallback={<div />}>{tab.component}</Suspense>
								</ScrollTabPanel>
							))}
						</Box>
					</Box>
				</div>
			</div>
		</div>
	);
};

export default ReportManagement;
